import {
  GET_COUNTRIES,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_ERROR,
  GET_STATES,
  GET_STATES_SUCCESS,
  GET_STATES_ERROR,
  CLIENT_STATES,
  CLIENT_STATES_SUCCESS,
  CLIENT_STATES_ERROR,
  CLIENT_COUNTRIES,
  CLIENT_COUNTRIES_SUCCESS,
  CLIENT_COUNTRIES_ERROR,
} from './commonConstants';

export const getCountries = (payload) => ({
  type: GET_COUNTRIES,
  payload,
});

export const getCountriesSuccess = (payload) => ({
  type: GET_COUNTRIES_SUCCESS,
  payload,
});

export const getCountriesError = (payload) => ({
  type: GET_COUNTRIES_ERROR,
  payload,
});

export const getStates = (payload) => ({
  type: GET_STATES,
  payload,
});

export const getStatesSuccess = (payload) => ({
  type: GET_STATES_SUCCESS,
  payload,
});

export const getStatesError = (payload) => ({
  type: GET_STATES_ERROR,
  payload,
});

export const getClientStates = (payload) => ({
  type: CLIENT_STATES,
  payload,
});

export const getClientStatesSuccess = (payload) => ({
  type: CLIENT_STATES_SUCCESS,
  payload,
});
export const getClientStatesError = (payload) => ({
  type: CLIENT_STATES_ERROR,
  payload,
});

export const getClientCountries = (payload) => ({
  type: CLIENT_COUNTRIES,
  payload,
});

export const getClientCountriesSuccess = (payload) => ({
  type: CLIENT_COUNTRIES_SUCCESS,
  payload,
});
export const getClientCountriesError = (payload) => ({
  type: CLIENT_COUNTRIES_ERROR,
  payload,
});
